export default __webpack_public_path__ + "static/media/Strap CT Too Big.60ef731b.mp4";